import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {Page} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/Page';
import {SurfacePage} from '@mintdata-wsp/pub/view/SurfacePage';
import {computed} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import {CSSProperties} from 'react';

const styles = require('./SurfaceArea.less');

@observer
export class SurfaceArea extends React.Component<any, any>
{
    private _refHandlers = {
        surface: (ref:HTMLElement | null) =>
        {
            if( !ref ) return;

            const {area} = rootState.ui.visualDesigner.surfaceEditor;
            area.surfaceAreaDomElement = ref;
        }
    };

    @computed
    private get _dndBoxStyles():CSSProperties
    {
        const {surfaceDnD} = commonControllers;

        return surfaceDnD.getDropTargetStyles();
    }

    @computed
    private get _scrollbarStyles():CSSProperties
    {
        const {surfaceArea} = commonControllers;

        return surfaceArea.getScrollbarStyles();
    }

    private _renderPages():Array<JSX.Element>
    {
        const designState = commonControllers.designState.getDesignState();

        if( !designState || !designState.surface || designState.surfaceSnapshot )
            return null;

        const {pages, activePage} = designState.surface;
        const allowAnimation:boolean = commonControllers.designState.getDesignState().surface.allowPagesAnimation;

        return Array.from(pages.values())
            .filter((page:Page) =>
            {
                const isActive:boolean = activePage ? activePage.id === page.id : false;

                if( isActive )
                    return true;

                const overlayIndex:number = commonControllers.designState.getIndexInOverlaysByPage(page);
                const isOverlay:boolean = overlayIndex !== -1;

                return isOverlay && !activePage.overlays[overlayIndex].isHidden;
            })
            .map((page:Page) =>
            {
                const isActive:boolean = activePage ? activePage.id === page.id : false;
                const overlayIndex:number = commonControllers.designState.getIndexInOverlaysByPage(page);
                const isOverlay:boolean = overlayIndex !== -1;
                const isHidden:boolean = isOverlay && activePage.overlays[overlayIndex].isHidden;

                return (
                    <SurfacePage
                        key={page.id}
                        page={page}
                        isActive={isActive}
                        isOverlay={isOverlay}
                        isHidden={isHidden}
                        stackIndex={overlayIndex}
                        allowAnimation={allowAnimation}
                    />
                );
            });
    }

    public render():JSX.Element
    {
        return <div
            className={styles.surfaceArea}
            ref={this._refHandlers.surface}
            {...this._dndBoxStyles}
            {...this._scrollbarStyles}
        >
            {this._renderPages()}
        </div>;
    }
}
